import cx from 'classnames';
import React from 'react';

interface SurfaceContainerProps {
  children: React.ReactNode;
  noBorder?: boolean;
  maxWidth?: number;
  className?: string;
  noBackdrop?: boolean;
}

export const SurfaceContainer = React.forwardRef<
  HTMLDivElement,
  SurfaceContainerProps
>(({ children, className = '', noBorder = false, maxWidth = null, noBackdrop = false }, ref) => (
  <div
    ref={ref}
    className={cx(
      'tw-w-full tw-h-full tw-bg-[var(--surface-background)] tw-rounded-[var(--border-radius-large)]',
      className,
    )}
    style={{
      maxWidth: maxWidth || undefined,
      border: noBorder ? '' : '1.4px solid var(--color-border-primary)',
      backdropFilter: noBackdrop ? '' : 'blur(20px)',
      boxShadow: '0 1px 4px 0 #0000000D',
    }}
  >
    {children}
  </div>
));

SurfaceContainer.displayName = 'SurfaceContainer';